import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import "./asset/css/style.css"
import "./asset/css/common.css"

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";
import Packages from "./pages/Packages";
import PackageDetail from "./pages/PackageDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import FlightResult from "./pages/Flight/FlightResult";
import BusResult from "./pages/Bus/BusResult";
import HotelResult from "./pages/Hotel/HotelResult";
import AllPackages from "./pages/AllPackages";
import ScrollToTop from "./component/ScrollToTop";
import Wallet from "./pages/Wallet/Wallet";
import Profile from "./pages/Wallet/Profile";
import BusBPDP from "./pages/Bus/BusBPDP";
import BusSeats from "./pages/Bus/BusSeats";
import ConfirmBooking from "./pages/Bus/ConfirmBooking";
import AllBookings from "./pages/AllBookings";
import BusInvoice from "./pages/Invoice/BusInvoice";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import BusFormNew from "./pages/Bus/BusFormNew";
import HotelSearch from "./pages/Hotel/HotelSearch";
import HotelDetail from "./pages/Hotel/HotelDetail";
import HotelCommit from "./pages/Hotel/HotelCommit";
import BookingSuccess from "./pages/Hotel/BookingSuccess";
import HotelInvoice from "./pages/Invoice/HotelInvoice";
import MobileRecharge from "./pages/DTH/MobileRecharge";
import BillPayment from "./pages/DTH/BillPayment";
import ElectricityBillDetail from "./pages/DTH/ElectricityBillDetail";
import WaterBillDetail from "./pages/DTH/WaterBillDetail";
import FlightSearch from "./pages/Flight/FlightSearch";
import FlightDetails from "./pages/Flight/FlightDetails";
import ElectricityInvoice from "./pages/Invoice/ElectricityInvoice";
import AllHotels from "./pages/OurHotel/AllHotels";
import HotelDetailCustom from "./pages/OurHotel/HotelDetailCustom";
import Checkout from "./pages/OurHotel/Checkout";
import HotelBookingInvoice from "./pages/OurHotel/HotelBookingInvoice";
import PreCheckoutPage from "./pages/OurHotel/PreCheckoutPage";
import PassengerDetails from "./pages/Flight/PassengerDetails";
import FlightInvoice from "./pages/Flight/FlightInvoice";


// Dummy pages (you can move these to separate files)
 

function App() {
  return (
    <Router>

<ScrollToTop />

      <Navbar/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/packages/:slug" element={<Packages />} />
        <Route path="/package/:id" element={<PackageDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/all-packages" element={<AllPackages />} />


        <Route path="/flight-result" element={<FlightResult />} />
        <Route path="/bus-result" element={<BusResult />} />
        <Route path="/hotel-result" element={<HotelResult />} />

        <Route path="/wallet" element={<Wallet />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/bus-points/:id" element={<BusBPDP />} />
        <Route path="/bus-seats/:id/:source/:desti" element={<BusSeats />} />
        <Route path="/confirm-booking" element={<ConfirmBooking />} />


        <Route path="/search-bus" element={<BusFormNew />} />
        <Route path="/hotels" element={<HotelSearch />} />
        <Route path="/hotel-detail/:token" element={<HotelDetail />} />
        <Route path="/hotel-commit" element={<HotelCommit />} />
        <Route path="/booking-success" element={<BookingSuccess />} />


        <Route path="/dth" element={<MobileRecharge />} />
        <Route path="/bill-payment" element={<BillPayment />} />
        <Route path="/bill-details" element={<ElectricityBillDetail />} />
        <Route path="/bill-details-water" element={<WaterBillDetail />} />


        <Route path="/flights" element={<FlightSearch />} />
        <Route path="/flight-details" element={<FlightDetails />} />
        <Route path="/passenger-details" element={<PassengerDetails />} />
        <Route path="/flightinvoice/:ticketId" element={<FlightInvoice />} />

   
 

        <Route path="/booking" element={<AllBookings />} />

        <Route path="/bus-invoice/:ticketId" element={<BusInvoice />} />
        <Route path="/hotel-invoice/:ticketId" element={<HotelInvoice />} />
        <Route path="/electricity-invoice/:ticketId" element={<ElectricityInvoice />} />
    



        <Route path="/hotel" element={<AllHotels />} />
        <Route path="/hotel-details/:uuid" element={<HotelDetailCustom />} />
        <Route path="/pre-checkout" element={<PreCheckoutPage />} />

        <Route path="/checkout" element={<Checkout />} />
        <Route path="/hotel-booking-success" element={<HotelBookingInvoice />} />
 



      </Routes>

      {/* <Footer/> */}

    </Router>
  );
}

export default App;
 